export const FEATURE_ENABLEMENT_STATUS = 'feature-enablement-status';
export const LEADS_FTP_CONFIG = 'leads-ftp-config';

export const REPORT_TYPE_OPTIONS = [
	{
		label: 'Feature Enablement Status',
		value: FEATURE_ENABLEMENT_STATUS,
	},
	{
		label: 'FTP Lead Configuration List',
		value: LEADS_FTP_CONFIG,
	},
];



// WEBPACK FOOTER //
// ./src/assets/js/constants/ReportOptions.js